"use client";

export default function LoginError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <main className="mx-auto flex min-h-screen max-w-md flex-col items-center justify-center bg-slate-50 px-6 py-16 text-slate-900">
      <div className="w-full rounded-2xl border border-red-200 bg-white p-8 shadow-sm">
        <h1 className="text-xl font-semibold text-red-700">Login page error</h1>
        <p className="mt-3 text-sm text-slate-600">
          {error.message || "Something failed while loading the login page."}
        </p>
        <p className="mt-4 text-sm text-slate-600">
          Common fixes: create <code className="rounded bg-slate-100 px-1">.env</code> at the repo root, run{" "}
          <code className="rounded bg-slate-100 px-1">npm install</code>, then{" "}
          <code className="rounded bg-slate-100 px-1">npm run dev</code> from{" "}
          <code className="rounded bg-slate-100 px-1">~/Projects/tender/frontend</code>.
        </p>
        <button
          type="button"
          onClick={reset}
          className="mt-6 rounded-lg border border-slate-200 bg-white px-4 py-2 text-sm hover:bg-slate-50"
        >
          Try again
        </button>
      </div>
    </main>
  );
}
